import { userService } from '../services'
import Vue from 'vue'

const state = {
  all: {
    loading: true,
    saving: false,
    items: [],
    filter: {},
    defaultFilter: {
      username: null,
      role: null,
      orderByColumn: 'fullName',
      orderByDescending: false
    },
    currentPage: 1,
    meta: {}
  }
}

const actions = {
  initialize ({ commit }) {
    commit('initialize')
  },

  resetFilter ({ commit }) {
    commit('resetFilter')
  },

  getAll ({ commit }) {
    return userService.getAll()
      .then(
        data => {
          commit('getAllSuccess', data.result)
          return data.result
        }
      )
  },

  getAllInRole ({ commit }, role) {
    return userService.getAllInRole(role)
      .then(
        data => {
          return data.result
        }
      )
  },

  getListData ({ commit }) {
    commit('getListDataRequest')

    userService.getListData(state.all.filter, state.all.currentPage)
      .then(data => {
        commit('getListDataSuccess', data.result)
      })
  },

  getById ({ commit }, id) {
    return userService.getById(id)
      .then(data => {
        return data.result
        // commit('getListDataSuccess', data.result)
      })
  },

  create ({ commit, dispatch }, user) {
    commit('startSave')
    return userService.create(user)
      .then(user => {
        commit('endSave')
        commit('createSuccess', user.result)
        dispatch('getListData')
        return user.result
      }).catch(error => {
        commit('endSave')
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  update ({ commit }, user) {
    commit('startSave')
    return userService.update(user)
      .then(user => {
        commit('endSave')
        commit('updateSuccess', user.result)
        return user.result
      }).catch(error => {
        commit('endSave')
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  externalUpdate ({ commit }, user) {
    commit('startSave')
    return userService.externalUpdate(user)
      .then(user => {
        commit('endSave')
        commit('updateSuccess', user.result)
        return user.result
      }).catch(error => {
        commit('endSave')
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit }, id) {
    commit('startSave')
    commit('deleteRequest', id)
    userService.delete(id)
      .then(user => {
        commit('endSave')
        commit('deleteSuccess', id)
      })
  },

  changePin ({ commit }, { newPin }) {
    commit('startSave')
    userService.changePin(newPin)
      .then(() => {
        commit('endSave')
        commit('changePinSuccess')
      })
      .catch(error => {
        commit('endSave')
        commit('changePinFailure', error)
      })
  },

  changePinAdmin ({ commit }, { id, newPin }) {
    commit('startSave')
    userService.changePinAdmin(id, newPin)
      .then(() => {
        commit('endSave')
        commit('changePinSuccess')
      })
      .catch(error => {
        commit('endSave')
        commit('changePinFailure', error)
      })
  }
}

const getters = {
  isFilterChanged: state => (route) => {
    // Page should not be considered when comparing
    const currentFilter = Object.assign({}, state.all.filter)
    const defaultFilter = Object.assign({}, state.all.defaultFilter)

    currentFilter.page = null
    defaultFilter.page = null

    return !Vue.lodash.isEqual(currentFilter, defaultFilter)
  }
}

const mutations = {
  resetFilter (state) {
    state.all.currentPage = 1
    state.all.filter = Object.assign({}, state.all.defaultFilter)
  },

  initialize (state) {
    if (!state.all.filterInitialized) {
      mutations.resetFilter(state)
      state.all.filterInitialized = true
    }
  },

  startSave (state) {
    state.all.saving = true
  },

  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  // Get all
  getListDataRequest (state) {
    state.all.loading = true
  },

  getListDataSuccess (state, data) {
    state.all.items = data.items
    state.all.meta = data.meta
    state.all.loading = false
  },

  getAllSuccess (state, data) {
    state.all.items = data
  },

  getListDataFailure (state, error) {
    state.all.error = error
    state.all.loading = false
  },

  // Create
  createSuccess (state, updatedUser) {
    /*
    state.all.items = state.all.items.map(user =>
      user.userId === updatedUser.userId ? updatedUser : user
    )
    */
    Vue.prototype.$toast('Användare skapad', 'success')
  },

  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa användare', 'error')
  },

  // Update
  updateSuccess (state, updatedUser) {
    state.all.items = state.all.items.map(user =>
      user.userId === updatedUser.userId ? updatedUser : user
    )

    Vue.prototype.$toast('Användare uppdaterad', 'success')
  },

  updateFailure (state) {
    console.log('NOW we are suddenly in error')
    Vue.prototype.$toast('Kunde inte uppdatera användare', 'error')
  },

  // Delete
  deleteRequest (state, id) {
    // add 'deleting:true' property to user being deleted
    state.all.items = state.all.items.map(user =>
      user.id === id
        ? { ...user, deleting: true }
        : user
    )
  },
  deleteSuccess (state, id) {
    // remove deleted user from state
    state.all.items = state.all.items.filter(user => user.id !== id)
  },
  changePinSuccess (state) {
    Vue.prototype.$toast('Lösenord ändrat', 'success')
  },
  changePinFailure (error) {
    console.error(error)
    Vue.prototype.$toast('Det gick inte att ändra lösenord', 'error')
  }
}

export const users = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/user.module.js